import { useState, useEffect } from "react";
import { SPORTS } from "../data/sports";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Multi-sport-ready hook. Initialises with the static catalogue (instant render)
 * then confirms/refreshes from the API. Falls back silently to static data.
 */
export function useSports() {
  const [sports, setSports] = useState(SPORTS);

  useEffect(() => {
    let active = true;
    fetch(`${API}/sports`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((data) => {
        if (active && Array.isArray(data) && data.length) {
          setSports(data);
        }
      })
      .catch(() => {
        /* keep static fallback */
      });
    return () => {
      active = false;
    };
  }, []);

  return sports;
}
